module.exports = __webpack_public_path__ + "static/media/logomain.81c69426.svg";